import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, USER_SESSION_LOGOUT, USER_SESSIONS, USER_SESSIONS_LOGOUT_ALL } from '../constants/actionTypes'

const userSessionsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const userSessionsStateSelector = createSelector(userSessionsSelector, state => state)

export const getUserSessionsSelector = createSelector(userSessionsSelector, data => data[USER_SESSIONS])

export const logoutUserSessionSelector = createSelector(userSessionsSelector, data => data[USER_SESSION_LOGOUT])

export const logoutAllUserSessionsSelector = createSelector(
  userSessionsSelector,
  data => data[USER_SESSIONS_LOGOUT_ALL]
)
